import { render, staticRenderFns } from "./Form50.vue?vue&type=template&id=2a53158a&scoped=true"
import script from "./Form50.vue?vue&type=script&lang=ts"
export * from "./Form50.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=2a53158a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53158a",
  null
  
)

export default component.exports